import { CoverListUrlSortField } from "@saleor/cover/urls";
import { CoverSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(sort: CoverListUrlSortField): CoverSortField {
  switch (sort) {
    case CoverListUrlSortField.name:
      return CoverSortField.NAME;
    case CoverListUrlSortField.createDate:
      return CoverSortField.CREATE_DATE;
    case CoverListUrlSortField.title:
      return CoverSortField.TITLE;
    case CoverListUrlSortField.subtitle:
      return CoverSortField.SUBTITLE;
    default:
      return undefined;
  }
}
export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
